// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Snapcode_wrapper__bM7KW"};